import { render } from "./BalancesHomeView.vue?vue&type=template&id=3720bf09&scoped=true"
import script from "./BalancesHomeView.vue?vue&type=script&lang=js"
export * from "./BalancesHomeView.vue?vue&type=script&lang=js"

import "./BalancesHomeView.vue?vue&type=style&index=0&id=3720bf09&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3720bf09"]])

export default __exports__